import { Injectable } from '@angular/core';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';
import { EventBenefit } from './event-benefit.model';
import { EventPriceBenefit } from './event-price-benefit.model';

@Injectable({
  providedIn: 'root',
})
export class EventV4BenefitService {
  private _eventServiceBaseUrl: string = '/event/v2/benefit/';

  public constructor(private _eventApiService: EventsServiceApiService) {}

  public getEventBenefits = (eventId: number, forceRefresh?: boolean): Promise<Array<EventBenefit>> => {
    let url: string = this._eventServiceBaseUrl + 'event/' + eventId.toString() + '/benefits';
    let cacheOptions = null;
    if (forceRefresh) {
      cacheOptions = this._eventApiService.getDefaultApiCacheOptionsForNoCache();
    }
    return this._eventApiService.get(url, cacheOptions).then((data: Array<EventBenefit>) => {
      for (let benefit of data) {
        for (let item of benefit.EventItems) {
          item.Selected = true;
        }
      }

      return Promise.resolve(data);
    });
  };

  public createEventBenefit = (benefit: EventBenefit): Promise<number> => {
    let selectedEventItems = new Array<EventPriceBenefit>();
    for (let item of benefit.EventItems) {
      if (item.Selected == true) {
        selectedEventItems.push(item);
      }
    }

    benefit.EventItems = selectedEventItems;
    return this._eventApiService.post(this._eventServiceBaseUrl, benefit);
  };

  public updateEventBenefit = (benefit: EventBenefit): Promise<void> => {
    let selectedEventItems = new Array<EventPriceBenefit>();
    for (let item of benefit.EventItems) {
      if (item.Selected) {
        selectedEventItems.push(item);
      }
    }
    benefit.EventItems = selectedEventItems;
    return this._eventApiService.put(this._eventServiceBaseUrl, benefit);
  };

  public deleteEventBenefit = (eventBenefitId: number): Promise<void> => {
    let url: string = this._eventServiceBaseUrl + eventBenefitId.toString();
    return this._eventApiService.delete(url);
  };
}
